import { toDate as r } from "./toDate.js";
function u(o, e) {
  const t = r(o);
  return t.setHours(e), t;
}
export {
  u as default,
  u as setHours
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setHours.js
// module id = 1439
// module chunks = 67